import React from "react";
import tw from "twin.macro";
import { withFlashSale } from "./withFlashSale";

const Wrapper = tw.div`
  bg-warning px-[1px] pb-mini pt-mini mb-midi text-center
`;

const Bold = tw.span`
  text-white uppercase text-[13px] font-medium leading-h3
`;

const Text = tw.span`
  text-white text-[11px] leading-h3
`;

const Pipe = tw(Text)`
  mx-mini
`;

const FlashSale = withFlashSale(({ title, description }) => {
  return (
    <Wrapper>
      <Bold>{title}</Bold>
      {description && (
        <>
          <Pipe aria-hidden="true">|</Pipe>
          <Text>{description}</Text>
        </>
      )}
    </Wrapper>
  );
});

export default FlashSale;
